import React from 'react';
import { useParams } from 'react-router-dom';

import { fieldObjectProaq } from './auxiliarProaq';
import { SubAbasProaq, SubAbasProaqId } from './subabas';
import DestaquesComponente from '../../../components/Destaques';
import { ENTITY } from '../../../utils/entityNames';

const ProaqDestaques: React.FC = () => {
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="proaq"
      id_tab={fichaID}
      retorno="/daf/proaq/processos"
      arquivo_export="sisaf_proaq_destaques.xlsx"
      fieldObject={fieldObjectProaq}
      subAbas={fichaID !== 'undefined' ? SubAbasProaqId(fichaID) : SubAbasProaq}
      entity={ENTITY.ENTITY_Proaq_Destaque}
    />
  );
};

export default ProaqDestaques;
